<template>
  <div class="vx-row" v-if="visitorData">
    <div class="vx-col w-1/2 md:w-1/4">
      <statistics-card-line
        hideChart
        class="mb-base"
        icon="UsersIcon"
        :statistic="visitorData.avg_visitor_perday"
        statisticTitle="Rata-rata"
        statisticSubtitle="Kunjungan perhari"
      />
    </div>
    <div class="vx-col w-1/2 md:w-1/4">
      <statistics-card-line
        hideChart
        class="mb-base"
        icon="UsersIcon"
        :statistic="visitorData.avg_visitor_perweek"
        statisticTitle="Rata-rata"
        statisticSubtitle="Kunjungan perminggu"
      />
    </div>
    <div class="vx-col w-1/2 md:w-1/4">
      <statistics-card-line
        hideChart
        class="mb-base"
        icon="UsersIcon"
        :statistic="visitorData.avg_visitor_permonth"
        statisticTitle="Rata-rata"
        statisticSubtitle="Kunjungan perbulan"
      />
    </div>
    <div class="vx-col w-1/2 md:w-1/4">
      <statistics-card-line
        hideChart
        class="mb-base"
        icon="UsersIcon"
        :statistic="visitorData.avg_visitor_peryear"
        statisticTitle="Rata-rata"
        statisticSubtitle="Kunjungan pertahun"
      />
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
  components: {
    StatisticsCardLine,
  },
  props: {
    visitorData: {
      required: true,
      type: Object
    }
  }
}
</script>